import React from 'react';

const BoligmappaPlusMenuIcon = ({
  width = '25',
  height = '19',
  fill = '#EF4923',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 19"
    fill="none"
    width={width}
    height={height}
    {...props}
  >
    <path
      d="M18.0405 8.37811H7.10652C6.34114 8.37811 5.68511 8.81547 5.35709 9.52618L2.02224 15.3758C1.53021 16.6332 2.40493 18 3.77167 18H14.7056C15.471 18 16.127 17.5626 16.455 16.8519L19.7899 11.0023C20.2819 9.74486 19.4072 8.37811 18.0405 8.37811Z"
      fill={fill}
    />
    <path
      d="M3.77221 7.8861C4.1549 7.06606 4.97494 6.51936 5.90433 6.51936H16.1822C16.5649 6.51936 16.7289 6.02733 16.5102 5.75399L10.6059 0.615034C9.67654 -0.205011 8.14579 -0.205011 7.16173 0.615034L0.710706 6.30068C0.273348 6.68337 0 7.1754 0 7.61275V13.0251C0 13.4624 0.601367 13.6264 0.820045 13.1891L3.77221 7.83143V7.8861Z"
      fill={fill}
    />
    <circle
      cx="17"
      cy="10.025"
      r="7"
      fill={fill}
      stroke="#F5F5F5"
      strokeWidth="2"
    />
    <path
      d="M17 7.02502L17 13.025"
      stroke="#F5F5F5"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14 10.025L20 10.025"
      stroke="#F5F5F5"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default BoligmappaPlusMenuIcon;
